export const GenericModalDutchTranslate = (text, type, section) => {
  switch (section) {
    case "create-new-assessment":
      return "Nieuwe beoordeling\u00A0aanmaken";
    case "confirmation-message1":
      return "Weet u zeker dat u ";
    case "confirmation-message2":
      return "wilt sluiten  en een nieuwe beoordeling wilt\u00A0openen?";
    case "note-message":
      return "Opmerking: zodra deze is gesloten, worden alle nieuwe resultaten meegenomen in de nieuwe\u00A0beoordeling.";
    case "confirm":
      return "Bevestigen";
    case "cancel":
      return "Annuleren";
    default:
      return text;
  }
}